import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/AuthPage.css";
import { SITE_URL } from "../../utils/siteUrl";

const THEME_KEY = "mtk-theme"; // same choice as the mytamilkart.com landing page

const readTheme = () => {
    try { return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light"; } catch (e) { return "light"; }
};

// Sign up and login: header (logo, theme) over the photo stage.
// `solo` shows the form alone; otherwise `aside` (the plan) sits beside it.
const AuthLayout = ({ solo, aside, children }) => {
    const { t } = useTranslation();
    const [theme, setTheme] = useState(readTheme);

    // Light by default; set as <html data-theme>, which the dashboard doesn't use
    useEffect(() => {
        const root = document.documentElement;
        root.setAttribute("data-theme", theme);
        try { localStorage.setItem(THEME_KEY, theme); } catch (e) { /* storage blocked */ }
        return () => root.removeAttribute("data-theme");
    }, [theme]);

    return (
        <div className="mtk-auth">
            <header className="bh">
                <div className="w">
                    <a className="logo" href={`${SITE_URL}/`} aria-label="MyTamilKart home">
                        <img src="/assets/img/auth/logo.png" alt="MyTamilKart" />
                    </a>
                    <div className="r">
                        <button
                            className="thm"
                            type="button"
                            aria-label={t(theme === "dark" ? "auth.theme_light" : "auth.theme_dark")}
                            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                        >
                            {theme === "dark" ? (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4.5" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
                            ) : (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>
                            )}
                        </button>
                    </div>
                </div>
            </header>

            <main className="stage">
                {/* The product photo collage behind the form (same image as the old signup page) */}
                <div className="bgc" aria-hidden="true" style={{ backgroundImage: "url(/assets/img/signup-bg.png)" }} />
                <div className={`duo2${solo ? " solo" : ""}`}>
                    {!solo && aside}
                    <section className="fcard">{children}</section>
                </div>
            </main>
        </div>
    );
};

export default AuthLayout;
